import { createSlice } from "@reduxjs/toolkit";


const initialState = [];

const pdfSlice = createSlice({
    name: 'diet',
    initialState,
    reducers: {}
})

export const { } = pdfSlice.actions;
export default pdfSlice.reducer;